import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  submitProjectReport(
    request: Boundaries["submitProjectReport"]["request"],
  ): void;
}

function useSubmitProjectReport(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isSubmitProjectReportRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isSubmitProjectReportRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isSubmitProjectReportRequestFailure(project),
    ),
    submitProjectReport: core.submitProjectReport,
  };
}

export { useSubmitProjectReport };
